import { combineReducers } from 'redux';

import {
    CREATE_SESSION_FAILURE,
    CREATE_SESSION_REQUEST,
    CREATE_SESSION_SUCCESS,
    LOGIN_FAILURE,
    SKIP_VALIDATION,
    VALIDATE_SESSION_FAILURE,
    VALIDATE_SESSION_SUCCESS,
} from '../actions/types/authentication-action-types';

function isSessionValid( state = false, action ){
    let newState;
    switch( action.type ){
        case VALIDATE_SESSION_SUCCESS:
        case CREATE_SESSION_SUCCESS:
            newState = true;
            break;
        case LOGIN_FAILURE:
        case VALIDATE_SESSION_FAILURE:
        case CREATE_SESSION_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function createSessionInFlight( state = false, action ){
    let newState;
    switch( action.type ){
        case CREATE_SESSION_REQUEST:
            newState = true;
            break;
        case LOGIN_FAILURE:
        case CREATE_SESSION_FAILURE:
        case CREATE_SESSION_SUCCESS:
        case SKIP_VALIDATION:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function userInfo( state = {}, action ){
    let newState;

    switch( action.type ){
        case VALIDATE_SESSION_SUCCESS:
        case CREATE_SESSION_SUCCESS:
            newState = { ...action.userInfo };
            break;
        case LOGIN_FAILURE:
        case CREATE_SESSION_FAILURE:
        case VALIDATE_SESSION_FAILURE:
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    createSessionInFlight,
    isSessionValid,
    userInfo
} );
